import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Tools\Image\RotateImageController::submit
* @see Http/Controllers/Tools/Image/RotateImageController.php:22
* @route '/{locale}/tools/image/rotate'
*/
export const submit = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

submit.definition = {
    methods: ["post"],
    url: '/{locale}/tools/image/rotate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Tools\Image\RotateImageController::submit
* @see Http/Controllers/Tools/Image/RotateImageController.php:22
* @route '/{locale}/tools/image/rotate'
*/
submit.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return submit.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Image\RotateImageController::submit
* @see Http/Controllers/Tools/Image/RotateImageController.php:22
* @route '/{locale}/tools/image/rotate'
*/
submit.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Image\RotateImageController::submit
* @see Http/Controllers/Tools/Image/RotateImageController.php:22
* @route '/{locale}/tools/image/rotate'
*/
const submitForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Tools\Image\RotateImageController::submit
* @see Http/Controllers/Tools/Image/RotateImageController.php:22
* @route '/{locale}/tools/image/rotate'
*/
submitForm.post = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: submit.url(args, options),
    method: 'post',
})

submit.form = submitForm

const rotate = {
    submit: Object.assign(submit, submit),
}

export default rotate